import React from 'react';
import { bool, func, object } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Money from '../../../core/components/money/Money';
import ProductDetails from './../../product-details/ProductDetails';
import ProductImage from './../../product-image/ProductImage';
import CheckoutButton from '../../../products/CheckoutButtonContainer';
import './KnowMoreModal.css';


function KnowMoreModal({
  product, active, onClickClose,
}) {
  if (!Object.keys(product).length) return <div />;
  const {
    title,
    advantage,
    type: productType,
    totalPrice: totPrice,
    characteristics,
  } = product;
  const classActive = active && 'active';
  const announceTitle = title.indexOf('Anúncio') !== -1 ? title : `Destaque ${title}`;

  return (
    <div className={`knowMore-background ${classActive}`}>
      <section className="knowMore">
        <div className="knowMore-close imageBase imageClose" onClick={onClickClose} />
        <div
          data-default-class="knowMore-icon imageBase imageInfo img"
          className="img"
        />
        <div className="clearfix" />
        <ProductImage type={productType} />
        <p className="knowMore-title title">{announceTitle}</p>
        <p className="knowMore-price price">
          <Money price={parseFloat(totPrice)} />
        </p>
        <div className="knowMore-description">
          <span className="visibility">
            <ReactMarkdown source={advantage} />
          </span>
        </div>
        <ProductDetails details={characteristics} notStylish />
        <CheckoutButton product={product} />
      </section>
    </div>
  );
}

KnowMoreModal.propTypes = {
  active: bool,
  onClickClose: func.isRequired,
  product: object.isRequired,
};

KnowMoreModal.defaultProps = {
  active: false,
};

export default KnowMoreModal;
